import { isNil } from "ramda";
import { Card, Grid, Input } from "@mantine/core";
import {
  ImgOption,
  TextOption,
} from "components/QuestionContent/MCQOptions.styles";
import HTMLReactParser from "html-react-parser";
import convertTagsToHTML from "helpers/convertTagsToHtml";
import MCQCorrectIcon from "assets/img/question/mcqCorrect.svg";
import MCQWrongIcon from "assets/img/question/mcqWrong.svg";
import styled from "styled-components";

const StyledImgOption = styled(ImgOption)`
  width: 100%;
`;
const StyledTextOption = styled(TextOption)`
  width: 100%;
`;

const Answer = ({ answer, index, hasImgOption }) => {
  const filteredHTML = answer.content.replace(/&nbsp;/g, " ");
  const isQnCorrect = null;
  const isAnswerInputDisabled = false;
  const isSelected = false;
  const isCorrect = null;
  return (
    <div style={{ width: 600, margin: "auto" }}>
      <Card padding="md" shadow="sm">
        <Card.Section style={{ padding: "20px" }}>
          <Grid>
            <Grid.Col span={2}>
              <div>
                <label>{`Answer ${index + 1}`}</label>
              </div>
            </Grid.Col>
            <Grid.Col span={2}>
              <div>
                <label>Id</label>
                <Input value={answer.id} disabled />
              </div>
            </Grid.Col>
            <Grid.Col span={3}>
              <div>
                <label>RefId</label>
                <Input value={answer.refId} disabled />
              </div>
            </Grid.Col>
            <Grid.Col span={3}>
              <div>
                <label>Content</label>
                {hasImgOption ? (
                  <StyledImgOption
                    data-cy={`option-img-${answer.refId}`}
                    key={answer.refId}
                    isAnswerInputDisabled={isAnswerInputDisabled}
                    isQnCorrect={isQnCorrect}
                    isCorrect={isCorrect}
                    selected={isSelected}
                    onClick={() => {}}
                  >
                    {HTMLReactParser(convertTagsToHTML(answer.content))}
                    {(isCorrect === true || isCorrect === false) && (
                      <img
                        className={`is-correct-icon ${
                          isCorrect
                            ? `correct-icon-${answer.refId}`
                            : `wrong-icon-${answer.refId}`
                        }`}
                        src={isCorrect ? MCQCorrectIcon : MCQWrongIcon}
                        alt={isCorrect ? "Correct" : "Wrong"}
                      />
                    )}
                  </StyledImgOption>
                ) : (
                  <StyledTextOption
                    data-cy={`option-${answer.refId}`}
                    key={answer.refId}
                    isAnswerInputDisabled={isAnswerInputDisabled}
                    isQnCorrect={isQnCorrect}
                    isCorrect={isCorrect}
                    selected={isSelected}
                    onClick={() => {}}
                  >
                    <p>{HTMLReactParser(convertTagsToHTML(filteredHTML))}</p>
                    {(isCorrect === true || isCorrect === false) && (
                      <img
                        className={`is-correct-icon ${
                          isCorrect
                            ? `correct-icon-${answer.refId}`
                            : `wrong-icon-${answer.refId}`
                        }`}
                        src={isCorrect === true ? MCQCorrectIcon : MCQWrongIcon}
                        alt={isCorrect === true ? "Correct" : "Wrong"}
                      />
                    )}
                  </StyledTextOption>
                )}
              </div>
            </Grid.Col>
          </Grid>
        </Card.Section>
      </Card>
    </div>
  );
};

const MCQAnswers = ({ parsedXML }) => {
  const correctOptions = parsedXML?.mcqOptions?.correctOptions ?? [];
  if (isNil(parsedXML)) return null;
  return (
    <div>
      {correctOptions.map((option, index) => (
        <Answer
          answer={option}
          index={index}
          key={option.id}
          hasImgOption={option.hasImgOption}
        />
      ))}
    </div>
  );
};

export default MCQAnswers;
